import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Richtext from '../molecules/richtext';
import { media } from '../../utils/media-queries';

export const ChatRichtext = ({ children }) => (
  <StyledChatRichtext className="spacing-outer-rich">
    {children}
  </StyledChatRichtext>
);

const StyledChatRichtext = styled.div`
  border: var(--border);
  background: var(--ee-color);
  max-width: 100%;
  p {
    font-family: var(--font-1);
    font-size: var(--fontsize-2);
    display: block;
    line-height: 1.25;
  }

  strong {
    font-family: var(--font-3);
    font-weight: inherit;
  }

  h4 {
    font-size: var(--fontsize-2);
    font-family: var(--font-3);
    padding-left: var(--spacing-M);
  }

  @media ${media.M} {
    max-width: 65%;
  }
`;

ChatRichtext.propTypes = {
  children: PropTypes.node,
};

export const ChatRichtextSanity = ({ blocks, key }) => (
  <StyledChatRichtext key={key} className="spacing-outer-rich">
    <Richtext blocks={blocks} />
  </StyledChatRichtext>
);

ChatRichtextSanity.propTypes = {
  blocks: PropTypes.array,
  key: PropTypes.string,
};
